module.exports = __webpack_public_path__ + "static/media/81v70ksZn0L._AC_UX569_.e87b6353.jpg";